import { api } from "@/lib/config";
import { useQuery } from "@tanstack/react-query";

export const useDepartmentOverview = ({ departmentId, startDate, endDate } = {}) => {
    return useQuery({
        queryKey: ["department-overview", departmentId, startDate, endDate],
        queryFn: async () => {
            const params = {
                startDate, endDate, departmentId
            }
            const response = await api.get(
                `get-department-timesheet-overview`, { params }
            );

            return response?.data?.data?.[0] || null;
        },
        // enabled: !!departmentId
    });
};
